<script setup lang="ts"></script>

<template>
  <div class="layout">
    <RouterView />
  </div>
</template>

<style scoped>
.layout {
  min-height: 100vh;
  height: 100%;
}
</style>
